AuthRoute = require 'mixins/authenticated-route'

App.OrdersCreateRoute = Em.Route.extend AuthRoute,
  session: Em.inject.service('session')

  createOrderByClient: (client_id, organization_id) ->
    order        = null
    client       = null
    organization = null

    @store.find('client', client_id)
    .then (cl) =>
      client = cl
      if organization_id
        return @store.find('organization', organization_id)
      else
        return client.get('organization')
    .then (org) =>
      organization = org

      order = @store.createRecord 'order',
        organization: organization,
        source: 'board'

      order.save()
    .then =>
      order.fillDefaultCity(false)
    .then =>
      order.setProperties
        client:        client
        contact_phone: client.get('phones.firstObject.number')
        contact_name:  client.get('name')

      Em.RSVP.hash
        order: order.save()
        buddies: order.get('buddies')
    .then (params) =>
      { buddies } = params

      owners = buddies.filter (b) => b.get('is_owner')

      promise = Em.RSVP.resolve()

      if owners.get('length')
        owner = owners.get('firstObject')

        owner.set('name',   client.get('name'))
        owner.set('avatar', client.get('avatar'))

        promise = owner.save()

      promise.then =>
        @transitionTo('orders.list.order', order)

  createOrderByNumber: (number, organization) ->
    order = @store.createRecord 'order',
      organization: organization,
      source: 'board'

    order.save()
    .then =>
      order.fillDefaultCity(false)
    .then =>
      order.set('contact_phone', number)
      order.save()
    .then =>
      @transitionTo('orders.list.order', order)

  model: (params, transition) ->
    { client_id, organization_id, number } = transition.queryParams

    unless organization_id
      organization_id = @get('session.availableOrganizations.firstObject.id')

    @store.find('organization', organization_id).then (organization) =>
      if client_id
        @createOrderByClient(client_id, organization_id)
      else if number
        @createOrderByNumber(number, organization)

